import { gql } from "@apollo/client";

// Strapi CMS collection type (expected): ticket-action
// GraphQL operations (expected): ticketActions, upsertTicketAction
// Fields expected in Strapi: customer, customerSite, auditId, auditLabel, auditOccupier, auditDateCompleted, category, section, question, response, notesId, actionSorting, actionName, owner, status, username?, email?

export const GET_TICKET_ACTIONS = gql`
  query GetTicketActions($filters: TicketActionFiltersInput) {
    ticketActions(filters: $filters, pagination: { start: 0, limit: -1 }) {
      data {
        id
        attributes {
          username
          email
          customer
          customerSite
          auditId
          auditLabel
          auditOccupier
          auditDateCompleted
          category
          section
          question
          response
          notesId
          actionSorting
          actionName
          owner
          status
          updatedAt
        }
      }
    }
  }
`;

export const UPSERT_TICKET_ACTION = gql`
  mutation UpsertTicketAction($input: TicketActionUpsertInput!) {
    upsertTicketAction(data: $input) {
      data {
        id
        attributes {
          username
          email
          customer
          customerSite
          auditId
          auditLabel
          auditOccupier
          auditDateCompleted
          category
          section
          question
          response
          notesId
          actionSorting
          actionName
          owner
          status
          updatedAt
        }
      }
    }
  }
`;
